(function() {
  // Skip on touch devices
  if ('ontouchstart' in window) return;

  function initMagnetic() {
    document.querySelectorAll('[data-magnetic]').forEach(function(btn) {
      var inner = btn.querySelector('span');

      btn.addEventListener('mousemove', function(e) {
        if (typeof gsap === 'undefined') return;
        var b = btn.getBoundingClientRect();
        var dx = e.clientX - (b.left + b.width / 2);
        var dy = e.clientY - (b.top + b.height / 2);
        gsap.to(btn, { x: dx * 0.35, y: dy * 0.35, duration: 0.4, ease: 'power2.out' });
        if (inner) {
          gsap.to(inner, { x: dx * 0.6, y: dy * 0.6, duration: 0.4, ease: 'power2.out' });
        }
      });

      btn.addEventListener('mouseleave', function() {
        if (typeof gsap === 'undefined') return;
        gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.3)' });
        if (inner) {
          gsap.to(inner, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.3)' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMagnetic);
  } else {
    initMagnetic();
  }
})();
